import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'Centros';

export interface Centro {
  idVersion: number;
  idCentro: string;
  descripcion: string;
  tipoCentro: string;
  idCentroPadre: string;
  idCentroDE: string;
  idCentroD2: string;
  idCentroDN: string;
  idCentroDG: string;
  idCentroSG: string;
}

export interface CentroUser {
	idCentro: string;
	descripcion: string;
	tipoCentro: string;
}

export class CentrosAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarCentros(): AxiosPromise<Centro[]> {
		return this.cliente.get(`/ListarCentros`);
	}

	ListarCentrosUsuario(login:string): AxiosPromise<CentroUser[]> {
		return this.cliente.get(`/ListarCentrosUsuario/${login}`);
	}
}